function createOverlay(image) {
  const overlayImage = document.createElement('img');
  overlayImage.setAttribute('src', image.src);

  const overlay = document.createElement('div');
  prepareOverlay(overlay, overlayImage);

  image.style.opacity = '50%';
  toggleLoadingSpinner(image);

  overlayImage.onload = () => {
    toggleLoadingSpinner(image);
    image.parentElement.insertBefore(overlay, image);
    image.style.opacity = '100%';
  };

  return overlay;
}

function prepareOverlay(container, image) {
  container.setAttribute('class', 'image-magnify-full-size');
  container.setAttribute('aria-hidden', 'true');
  container.style.backgroundImage = `url('${image.src}')`;
  container.style.backgroundColor = 'var(--gradient-background)';
}

function toggleLoadingSpinner(image) {
  const spinner = image.parentElement?.parentElement?.querySelector('.loading__spinner');
  if (spinner) spinner.classList.toggle('hidden');
}

function moveWithHover(image, overlay, event, zoomRatio) {
  const ratio = image.height / image.width;
  const rect = image.getBoundingClientRect();

  const x = event.clientX - rect.left;
  const y = event.clientY - rect.top;

  const xPercent = `${x / (image.clientWidth / 100)}%`;
  const yPercent = `${y / ((image.clientWidth * ratio) / 100)}%`;

  overlay.style.backgroundPosition = `${xPercent} ${yPercent}`;
  overlay.style.backgroundSize = `${image.width * zoomRatio}px`;
}

function magnify(image, zoomRatio) {
  const overlay = createOverlay(image);

  overlay.addEventListener('click', () => overlay.remove());

  overlay.addEventListener('mousemove', (event) =>
    moveWithHover(image, overlay, event, zoomRatio)
  );

  overlay.addEventListener('mouseleave', () => overlay.remove());

  return overlay;
}

function enableZoomOnHover(zoomRatio) {
  const images = document.querySelectorAll('.image-magnify-hover');

  images.forEach((image) => {
    // Prevent duplicate listeners
    if (image.dataset.zoomBound === 'true') return;

    image.dataset.zoomBound = 'true';

    image.addEventListener('click', (event) => {
      const overlay = magnify(image, zoomRatio);
      moveWithHover(image, overlay, event, zoomRatio);
    });
  });
}

/* --------------------------
   INIT + AUTO-REBIND LOGIC
--------------------------- */

function initZoom() {
  enableZoomOnHover(2);
}

function observeGallery() {
  const observer = new MutationObserver(() => {
    initZoom();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });
}

// Initial load
document.addEventListener('DOMContentLoaded', () => {
  initZoom();
  observeGallery();
});